export enum ActionType {
  Duplicate = 'Duplicate',
  Delete = 'Delete',
}

export type ActionTypeKey = keyof typeof ActionType
